module.exports = __webpack_public_path__ + "media/openWin.b055e616.mp4";